import React, { memo, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./Modal.module.css";

const ContactModal = memo(({ isOpen, onClose }) => {
  const { websiteSetting } = useSelector((state) => state.user);

  // Extract Line and Telegram URLs from websiteSetting
  const settings = Array.isArray(websiteSetting)
    ? websiteSetting[0]
    : websiteSetting?.data?.[0] || {};
  const lineUrl = settings?.lineUrl || "https://line.me/";
  const teleUrl = settings?.teleUrl || "https://telegram.org/";

  const handleOverlayClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose],
  );

  const handleEscapeKey = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, handleEscapeKey]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={`${styles.modal} ${styles.contactModal}`}>
        <div className={styles.contactHeader}>
          <h2 className={styles.contactHeaderTitle}>ติดต่อเรา</h2>
          <button
            type="button"
            className={styles.contactCloseButton}
            onClick={onClose}
            aria-label="ปิด"
          >
            ✕
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.contactInfo}>
            <div
              className={styles.contactItem}
              onClick={() => window.open(lineUrl, "_blank")}
              style={{
                cursor: "pointer",
                padding: "15px",
                borderRadius: "10px",
                border: "2px solid #00B900",
                backgroundColor: "#f8fff8",
                transition: "all 0.3s ease",
                marginBottom: "15px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#e8f5e8";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(0, 185, 0, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#f8fff8";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              <img
                src="https://space.pgzone88.com/line.webp"
                alt="Line"
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "8px",
                }}
              />
              <div style={{ marginLeft: "8px", textAlign: "left" }}>
                <h3
                  className={styles.contactTitle}
                  style={{
                    margin: 0,
                    color: "#00B900",
                    fontSize: "24px",
                  }}
                >
                  Line
                </h3>
                <p
                  className={styles.contactText}
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  ติดต่อผ่าน Line Official
                </p>
              </div>
            </div>

            <div
              className={styles.contactItem}
              onClick={() => window.open(teleUrl, "_blank")}
              style={{
                cursor: "pointer",
                padding: "15px",
                borderRadius: "10px",
                border: "2px solid #0088cc",
                backgroundColor: "#f8fcff",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#e8f4ff";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(0, 136, 204, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#f8fcff";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              <img
                src="https://space.pgzone88.com/telegram.webp"
                alt="Telegram"
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "8px",
                }}
              />
              <div style={{ marginLeft: "8px", textAlign: "left" }}>
                <h3
                  className={styles.contactTitle}
                  style={{
                    margin: 0,
                    color: "#0088cc",
                    fontSize: "24px",
                  }}
                >
                  Telegram
                </h3>
                <p
                  className={styles.contactText}
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  ติดต่อผ่าน Telegram Bot
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

ContactModal.displayName = "ContactModal";

export default ContactModal;
